module.exports = __webpack_public_path__ + "img/online.e69d224.svga";